export enum ActionPlanListType {
  series = 'series',
  individual = 'individual',
}
